export default __webpack_public_path__ + "static/media/BrainBreak cards67.0d18c84c.png";